// Define a branded type for Base64 strings
export type Base64 = string & { readonly __brand: unique symbol };

// Function to create a Base64 branded string
export function toBase64(input: string): Base64 {
  const encoded = btoa(input); // Use btoa for base64 encoding
  return encoded as Base64;
}

export function fromBase64(input: Base64): string {
  const decoded = atob(input); 
  return decoded as string;
}

// Function to validate if a string is a valid Base64
export function isBase64(str: string): str is Base64 {
  try {
    return btoa(atob(str)) === str;
  } catch {
    return false;
  }
}
